import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import assign from 'lodash/assign';
import { imageSizesLookup } from '../../../utils/cloudinary_asset_util';
import { setModifierClass } from '../../../utils/create_class_list_util';
import Slug from '../slug/slug';
import Card from '../card/card';
import Advertorial, { isAdvertorial } from '../advertorial/advertorial';

function buildSlugWrapperClass(advertorial) {
  const className = 'homepage-tag__advertorial-title-container';
  // TODO: change class modifier on setModifierClass
  const slugTitle =
    setModifierClass(advertorial, className, 'advertorial') || className;
  return slugTitle;
}

function renderSlug(data, tags, advertorial) {
  const pageLink = get(data, 'slug') ? `/section/${get(data, 'slug')}` : '';
  const slugName = get(data, 'name') || 'more stories';

  return (
    <div className={buildSlugWrapperClass(advertorial)}>
      <div>
        <Slug slugName={slugName} linkTo={pageLink} />
        {advertorial ? (
          <Advertorial
            modifier="homepage-deck"
            tags={tags}
            section="homepage"
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default function MoreStories(props) {
  if (!props) {
    return null;
  }

  const { config, metadata, slugData, tags, isPost } = props;
  const advertorial = isAdvertorial(tags);

  return (
    <section className={isPost ? 'post-more-stories' : 'more-stories-module'}>
      {renderSlug(slugData, tags, advertorial)}
      <div className="row">
        {metadata.map((post, i, arr) => (
          <Card
            key={post.id}
            metadata={assign(post, {
              assetSizes:
                i === 0
                  ? imageSizesLookup.bigFirstMobile
                  : imageSizesLookup[arr.length]
            })}
            config={config}
            totalCards={arr.length}
          />
        ))}
      </div>
    </section>
  );
}

MoreStories.defaultProps = {
  tags: [],
  isPost: false,
  slugData: {}
};

MoreStories.propTypes = {
  config: PropTypes.shape({}).isRequired,
  metadata: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  slugData: PropTypes.shape({}),
  tags: PropTypes.arrayOf(PropTypes.shape({})),
  isPost: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/views/components/more-stories-component/more-stories-component.js